import React, { useEffect, useState } from 'react'
import { FaShieldAlt } from "react-icons/fa";

const NoDataComp = () => {
    const [areaName, setAreaName] = useState('');

    useEffect(() => {
        try {
            // Get user data from localStorage
            const userDataStr = localStorage.getItem('userData');
            if (!userDataStr) {
                setAreaName('your area');
                return;
            }

            const userData = JSON.parse(userDataStr);
            const role = localStorage.getItem('role');

            // For area role, use area_ids.name
            if (role && role.includes('area') && userData.area_ids) {
                if (userData.area_ids.name) {
                    setAreaName(userData.area_ids.name);
                } else {
                    setAreaName(userData.area_ids);
                }
            }
            // Otherwise use factory name
            else if (userData.factory?.name) {
                setAreaName(userData.factory.name);
            } else {
                setAreaName('your area');
            }
        } catch (error) {
            setAreaName('your area');
        }
    }, []);

    return (
        <>
            <div className="w-100 d-flex justify-content-center align-items-center align-content-center" style={{ height: "75vh" }}>
                <div className="d-flex align-items-center justify-content-center flex-column" style={{ height: "40vh", borderRadius: '8px', margin: '20px 0' }}>
                    <div className="text-center p-5">
                        <div className="mb-3">
                            <span style={{ backgroundColor: '#54BA4A', color: 'black', borderRadius: '50%', width: '40px', height: '40px', display: 'inline-flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
                                <i className="fa fa-check" style={{ fontSize: '24px' }}></i>
                            </span>
                        </div>
                        <h3 style={{ color: 'black', fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>All Clear!</h3>
                        <p style={{ color: 'black', fontSize: '16px', marginBottom: '10px' }}>
                            No safety violations detected for this area.
                        </p>
                        <p style={{ color: 'black', fontSize: '16px', marginBottom: '15px' }}>
                            {areaName ? `Your area ${areaName} is compliant with all safety standards for now.` :
                            'Your area is compliant with all safety standards for now.'}
                        </p>
                        <p style={{ color: 'black', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaShieldAlt size={20} color='#FF0000' className="me-2" />
                            Keep up the great work in maintaining a safe environment!
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NoDataComp
